'use client';

import { useAuthStore } from '@/stores/useAuthStore';

export default function DashboardScoreUnit() {
    const userScore = useAuthStore((s) => s.userScore);

    const totalScore = userScore?.totalScore ?? 0;
    const medalScore = userScore?.totalMedalScore ?? 0;
    const badgeScore = userScore?.totalBadgeScore ?? 0;
    const activityScore = Math.max(totalScore - medalScore - badgeScore, 0);
    const denom = medalScore + badgeScore + activityScore || 1;
    const widthOf = (n: number) => `${(n / denom) * 100}%`;

    const breakdown = [
        { label: 'メダル', value: medalScore, color: '#E8590C' },
        { label: 'バッジ', value: badgeScore, color: '#EAA81E' },
        { label: 'アクティビティ', value: activityScore, color: '#9A9890' },
    ];

    return (
        <div className="flex flex-col w-full rounded-2xl bg-color-white-base px-4 py-3">
            <span className="font-corp font-bold text-xs text-color-base">スクーマーズスコア</span>
            <div className="font-cantarell font-bold text-3xl md:text-4xl leading-none text-color-c-orange pt-1">
                {totalScore}
            </div>

            <div className="flex w-full h-2.5 mt-3 rounded-full overflow-hidden bg-color-co-gray-light">
                {breakdown.map(({ label, value, color }) => (
                    <div key={label} style={{ width: widthOf(value), backgroundColor: color }} />
                ))}
            </div>

            <div className="flex flex-col gap-y-1 mt-2">
                {breakdown.map(({ label, value, color }) => (
                    <div key={label} className="flex items-center gap-x-2">
                        <span
                            className="inline-block w-2 h-2 rounded-sm flex-none"
                            style={{ backgroundColor: color }}
                        />
                        <span className="font-corp text-xs text-color-co-gray-dark">{label}</span>
                        <span className="font-cantarell font-bold text-xs text-color-base ml-auto">{value}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}
